"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var StatusWarningSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M10.7037499,3.9623322 L15.7092882,11.9592754 C15.9070807,12.2850514 16.000829,12.6448689 16.0000703,13 C15.9984263,13.6741191 15.6560657,14.3313518 15.0376694,14.7068067 C14.7247801,14.8967752 14.3657565,14.9972317 13.9997131,14.9972317 L4,14.9999167 C2.8954305,14.9999167 2,14.1045695 2,13 C2,12.6339566 2.10045645,12.2749331 2.29042497,11.9620437 L7.28459986,3.9623322 C7.66164996,3.34130849 8.32287747,2.99867105 9,2.99991673 C9.35233944,3.00069152 9.70898264,3.09451612 10.0321312,3.29071343 C10.3066867,3.45740786 10.5370555,3.68777667 10.7037499,3.9623322 Z M9.85610665,4.49289877 L9.8489624,4.48131033 C9.76561519,4.34403256 9.65043079,4.22884816 9.51315302,4.14550095 C9.3544272,4.0491317 9.17815604,4.00031424 8.99815026,3.99991836 C8.64898821,3.99927598 8.32355373,4.17797751 8.13286707,4.49190064 L3.14521248,12.4810219 C3.05022823,12.6374665 3,12.8169783 3,13 C3,13.5522583 3.44768885,13.9999184 3.99973081,13.9999184 L13.9997131,13.9972317 C14.1827348,13.9972317 14.3622466,13.9470035 14.5186913,13.8520192 C14.8207235,13.6686425 14.9992209,13.3452287 15.000068,12.9978373 C15.0004565,12.8160591 14.9516364,12.6382419 14.8616449,12.489842 L9.85610665,4.49289877 Z M9,6 C9.55228475,6 10,6.44771525 10,7 L10,9 C10,9.55228475 9.55228475,10 9,10 C8.44771525,10 8,9.55228475 8,9 L8,7 C8,6.44771525 8.44771525,6 9,6 Z M9,11 C9.55228475,11 10,11.4477153 10,12 C10,12.5522847 9.55228475,13 9,13 C8.44771525,13 8,12.5522847 8,12 C8,11.4477153 8.44771525,11 9,11 Z" })));
};
StatusWarningSmall.displayName = 'StatusWarningSmall';
exports.default = StatusWarningSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=StatusWarningSmall.js.map